"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:5.1.4'] && _();
}
catch (e) { }
